import React from 'react';
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";


export const Select = ({data, formControlProps, inputLabelProps, selectProps, onChange = null, value = '', uniqueKey}) => {
    return <TextField
            id={`${uniqueKey}-selector`}
            value={value || ''}
            onChange={onChange}
            SelectProps={selectProps}
            InputLabelProps={inputLabelProps}
            select
            {...formControlProps}
        >
            {data.map((el, index) => <MenuItem key={`${uniqueKey}-selector-menuitem-${index}`}
                                               value={el.id}>{el.name}</MenuItem>)}
        </TextField>

}
